import { api } from './client.js';

// Heartbeat (any role) — marks the current user as live.
// body (clients only): { page: { kind, label }, cart: { subtotal, units, lines } | null }
export const pingPresence = (body) => api.post('/presence/ping', body || {}).then((r) => r.data);
// Live visitor count + role breakdown (staff only) — for the dashboard pill.
export const fetchPresence = () => api.get('/presence').then((r) => r.data);
// Who's online right now (clients, with their company) — staff only.
export const fetchWhoIsOnline = () => api.get('/presence/who').then((r) => r.data.users);
